import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})

export class ApiClientService {

  constructor(public http: HttpClient) { }

  //define api endpoints here

  public getDefObject(data: any) {

  	var data: any;

    return this.http.post(`${environment.apiUrl}/get-definition-object` , data)
      .subscribe(
        data => {console.log(data); data = data; },
        err => {console.log(err);  return false; },
        () => {return data; }
      );
  }

  public updateUserData(data: any) {

  	var data: any;

    return this.http.post(`${environment.apiUrl}/update-context-data` , data)
      .subscribe(
        data => {console.log(data); data = data; },
        err => {console.log(err);  return false; },
        () => {return data; }
      );
  }

}
